var _rect, _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _rect2, _path8, _path9, _path10, _g2, _path11, _circle, _circle2, _circle3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.0582,
    y: 103.644,
    width: 95.3036,
    height: 58.6484,
    rx: 0.733105,
    transform: "rotate(-9.94264 65.0582 103.644)",
    stroke: "#5C5C5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2704 103.793L117.754 128.272L158.782 87.4007",
    stroke: "#5C5C5C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3335 161.199L105.593 122.588",
    stroke: "#5C5C5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.845 144.807L127.256 118.791",
    stroke: "#5C5C5C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.327 106.838L175.656 107.523C176.061 107.543 176.372 107.888 176.351 108.292L173.419 165.399C173.398 165.804 173.054 166.115 172.649 166.094L78.6758 161.269C78.4147 161.256 78.2139 161.033 78.2274 160.772V160.772",
    stroke: "#5C5C5C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.196 107.734L163.976 115.372",
    stroke: "#5C5C5C",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.208 165.939L154.788 147.577",
    stroke: "#5C5C5C",
    strokeWidth: 0.5
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.7816 108.397L65.7401 107.806L74.9039 160.223C75.0505 161.102 75.8203 161.322 76.1869 161.322L162.327 146.294L163.06 149.593L73.2399 165.593C72.8425 165.664 72.4627 165.4 72.3902 165.003L62.2042 109.248C62.1322 108.854 62.3892 108.476 62.7816 108.397Z",
    fill: "url(#paint0_linear_252_1882)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156.279 100.108C162.352 100.108 167.275 95.1846 167.275 89.1113C167.275 83.0381 162.352 78.1147 156.279 78.1147C150.205 78.1147 145.282 83.0381 145.282 89.1113C145.282 95.1846 150.205 100.108 156.279 100.108Z",
    fill: "#5C5C5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M158.903 93V91.635H157.346V84.6182H156.101L154.448 85.4085V86.6897L155.885 86.1868V91.635H154.329V93H158.903Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3605 190.637L38.7104 221.113C37.5541 223.109 36.9408 225.37 36.9318 227.67C36.9229 229.97 37.5188 232.227 38.6596 234.214L56.073 264.553C57.2135 266.54 58.8587 268.188 60.8433 269.33C62.8278 270.472 65.0818 271.069 67.3785 271.06L102.444 270.925C104.74 270.915 106.998 270.301 108.992 269.143C110.985 267.985 112.642 266.325 113.798 264.329L131.448 233.854C132.604 231.858 133.218 229.597 133.227 227.297C133.236 224.998 132.641 222.741 131.501 220.754L114.086 190.413C112.945 188.426 111.3 186.778 109.315 185.636C107.331 184.494 105.077 183.897 102.78 183.907L67.7167 184.043C65.42 184.051 63.1614 184.665 61.1679 185.823C59.1745 186.981 57.5164 188.641 56.3605 190.637V190.637Z",
    stroke: "url(#paint1_linear_252_1882)",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 160.09,
    y: 35.507,
    width: 49.2406,
    height: 89.1655,
    rx: 4.65079,
    transform: "rotate(-30.7793 160.09 35.507)",
    stroke: "url(#paint2_linear_252_1882)",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M171.523 28.6965L172.915 31.0323C173.745 32.426 175.548 32.8829 176.941 32.0527L191.141 23.595C192.535 22.7649 192.992 20.9621 192.161 19.5683L190.77 17.2326",
    stroke: "#5C5C5C",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.087 28.0141L187.234 22.5659",
    stroke: "#5C5C5C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.73 41.4215L163.243 40.5431L204.114 109.088C206.313 111.141 208.94 110.188 209.979 109.455L226.29 99.3748L230.505 105.973L208.54 118.225C205.769 119.771 202.271 118.833 200.646 116.107L160.03 47.9826C158.671 45.7036 159.436 42.7538 161.73 41.4215Z",
    fill: "url(#paint3_linear_252_1882)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 40.3011,
    ry: 40.2541,
    transform: "matrix(0.95781 -0.287405 0.289802 0.957087 38.2665 50.1481)",
    stroke: "url(#paint4_linear_252_1882)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2085 59.7078L71.4697 61.9029C72.4568 62.1368 73.4466 61.5263 73.6786 60.5402L74.3735 57.587C74.6048 56.6039 73.9954 55.6193 73.0113 55.386L63.7424 53.1891",
    stroke: "#5C5C5C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 25.6976,
    ry: 25.7683,
    transform: "matrix(0.228859 -0.972689 0.974262 0.228714 38.1529 50.0879)",
    stroke: "#5C5C5C",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 22.3458,
    ry: 22.4072,
    transform: "matrix(0.228859 -0.972689 0.974262 0.228714 38.1526 50.0874)",
    fill: "url(#paint5_linear_252_1882)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6599 72.6969C66.6441 80.074 59.1483 85.8444 49.9217 88.6169C28.5902 95.0267 6.08514 82.9843 -0.344759 61.7195C-3.2922 51.9717 -2.35018 41.9782 1.5895 33.395C-4.991 43.0735 -7.30281 55.5173 -3.65406 67.5844C2.77584 88.8492 25.2809 100.892 46.6124 94.4818C58.1656 91.0102 67.0051 82.838 71.6599 72.6969Z",
    fill: "url(#paint6_linear_252_1882)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 170.208,
    cy: 166.087,
    r: 15.7618,
    stroke: "#5C5C5C",
    strokeWidth: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 170.208,
    cy: 166.087,
    r: 28.5911,
    stroke: "#5C5C5C",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 170.208,
    cy: 166.087,
    r: 41.0539,
    stroke: "#5C5C5C",
    strokeWidth: 0.5,
    strokeDasharray: "2.2 2.2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_252_1882",
    x1: 70.1387,
    y1: 90.7609,
    x2: 136.485,
    y2: 162.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_252_1882",
    x1: 93.3465,
    y1: 176.351,
    x2: 78.7242,
    y2: 231.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_252_1882",
    x1: 159.074,
    y1: 52.7117,
    x2: 202.652,
    y2: 97.4234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_252_1882",
    x1: 157.378,
    y1: 59.7871,
    x2: 222.991,
    y2: 86.5454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_252_1882",
    x1: 59.9955,
    y1: 75.805,
    x2: 30.128,
    y2: 19.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_252_1882",
    x1: 13.1835,
    y1: -31.576,
    x2: 20.3572,
    y2: 18.9545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_252_1882",
    x1: 92.6112,
    y1: 75.9151,
    x2: 7.49745,
    y2: 87.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4D4D",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.9d1c24385af9ace03a8b321c16cc8ae7.svg";
export { ForwardRef as ReactComponent };